<template>
    <div>
        <transition name="ani-slide-in">
            <qrcode-scan @decodedQr="decoded"></qrcode-scan>
        </transition>
      <v-container>
        <v-row>
          <v-col v-if="!show_btn && scanned_content.length >= 1" offset="1" cols="10" class="text-center">

            <p class="muted">QR-DATA : {{scanned_content}}</p>

          </v-col>
          <v-col offset="1" cols="10" class="text-center">
            <v-btn v-if="show_btn" color="success" x-large dark target="_blank" @click="buttonClicked">
              {{cta}}
            </v-btn>
          </v-col>
        </v-row>

      </v-container>

    </div>
</template>
<script>
import SharedQrCodeScannerComponent from "@/components/modules/qrCodeScanner/SharedQrCodeScannerComponent";
import {urlValidator} from "@/helpers/url/urlValidator";
export default {
    name : "QrCodeScanner",
    components : {
        QrcodeScan : SharedQrCodeScannerComponent
    },
    data (){
      return {
        show_btn : false,
        location : '',
        cta : '',
        scanned_content : '',
      }
    },
    methods : {
      decoded(decodedString){
        if(urlValidator.validURL(decodedString)){
          this.show_btn = true;
          this.location = decodedString;
          if(decodedString.startsWith('youtu.be', 8)){
            this.cta = "Open video";
          }else{
            this.cta = "Open link";
          }

        }else{
          //console.log('invalid url');
          this.show_btn = false;
          this.location = '';
          this.scanned_content = decodedString
        }
      },
      buttonClicked(){
        window.open(this.location, '_blank');
        this.$router.replace('/');
      }
    }
}
</script>